module.exports = __webpack_public_path__ + "img/linse_bund_raa.a169a030.jpg";